// extracted by mini-css-extract-plugin
export default {"wrapper":"sharedWith_wrapper__GsUCd","popoverContent":"sharedWith_popoverContent__fXLrx"};